module.exports = __webpack_public_path__ + "static/media/bgi-talentx-main-mobile@3x.f7bbe21c.png";